module.exports = __webpack_public_path__ + "img/service-cart.ab5131fe.png";